import { Autocomplete } from '../fields';
import { LabelRequired } from '../custom/LabelRequired';
import { useTranslation } from 'react-i18next';
import useAppSubmitting from '../../hooks/useAppSubmitting';
import useAccounts from '../../hooks/useAccounts';
import useConnectionMode from '../../hooks/useConnectionMode';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';
import amIVisible from '../../componentControl/registry';
import { useDispatch } from 'react-redux';
import { useNotification } from '../../utils/helpers/notifications';
import { setCurrentComponent } from '../../slices/dashboardSlice';
import { Text } from '../custom/text';
import { Card, Skeleton } from 'antd';
import { Flex } from '@react-css/flex';
import { Box } from '../custom/box';

export const MapDefaultServiceAccount = ({ formik }) => {
  const { showNotification } = useNotification();
  const [isAppSubmitting] = useAppSubmitting();
  const { postingMethod, defaultServiceAccount } = formik.values
  const isTypeCategory = postingMethod !== 'invoice';
  const [isLoadingAccounts, accountsList] = useAccounts('items');
  const [, softwareName] = useConnectionMode();
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();
  const isLoading = isInputsOnlyLayout ? false : isLoadingAccounts;
  const canShowSalesIndividual = amIVisible("service individual")
  const dispatch = useDispatch()
  const canShowBothProductAndCategories = amIVisible("service can show both product and categories")
  const canUseServiceCategories = amIVisible("service by categories")

  if (isTypeCategory && !canUseServiceCategories) {
    return null
  }

  const gotoMapping = () => {
    if (formik.dirty) {
      showNotification("Save the current changes to proceed", "error")
    } else {
      let comp = 'product'
      if (!isTypeCategory && canShowBothProductAndCategories) {
        comp = canUseServiceCategories ? 'category' : 'product'
      } else if (isTypeCategory) {
        comp = canUseServiceCategories ? 'category' : 'product'
      }

      dispatch(setCurrentComponent("service " + comp + " mapping"))
    }
  };

  const handleNavigation = () => {
    if (isAppSubmitting) {
      showNotification(t('Please wait for data to save'), 'error');
    } else if (defaultServiceAccount) {
      gotoMapping();
    } else {
      showNotification(t(isInputsOnlyLayout ? 'DefaultAccountTextInputFirst' : 'DefaultAccountFirst'), 'error');
    }
  }

  const getLabel = () => {
    if (!isTypeCategory && canShowBothProductAndCategories && canUseServiceCategories) {
      return "Map individual services and service categories"
    } else if (isTypeCategory && canUseServiceCategories) {
      return "Map individual service categories"
    }

    return "Map individual services"
  }

  return <Card type="inner"   title={
    <Text fontSize={"large"} fontWeight="bolder">{isTypeCategory ? 'Service by categories' : 'Service by products'}</Text>
  } style={{ marginBottom: "1rem" }}>
    <Text color="gray-600" size="small">
      {t(
        isTypeCategory ? 'SalesByCategoryDescription' : 'SalesByProductDescription', {
        swName: softwareName,
      })}
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="defaultServiceAccount">
          {t('Default service account')}
        </LabelRequired>
        <Autocomplete
          id="defaultServiceAccount"
          name="defaultServiceAccount"
          isLoading={isLoading}
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter default service account' : 'Select an account')
          }
        />
      </Box>
      {canShowSalesIndividual && <Flex style={{ marginTop: "45px" }}>
        {isLoading ?
          <Skeleton.Input size="small" /> :
          <Text link size="small" fontWeight="bolder" onClick={handleNavigation}>
            {getLabel()}
          </Text>
        }
      </Flex>}
    </Flex>
  </Card>;
};
